var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(1 0 0 1 -1886 -568 )"},React.createElement("path",{"d":"M 4 32.67  L 0.226666666666669 28.9344  L 12.4533333333333 16.83  L 0.226666666666669 4.7256  L 4 0.99  L 20 16.83  L 4 32.67  Z ","fillRule":"nonzero","fill":"#fe0000","stroke":"none","transform":"matrix(1 0 0 1 1886 568 )"})));
}

ArrowInline.defaultProps = {"version":"1.1","width":"20px","height":"33px"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
